import { styled } from 'linaria/react';
import { css } from 'linaria';

export const RoomParametersFormControls = styled.div`
  position: relative;
  width: 100%;
  max-width: 552px;

  @media (--to-tablet) {
    max-width: 100%;
  }
`;

export const RoomParametersFormWrapper = styled.div<{ fixedArea?: boolean }>`
  position: relative;
  display: flex;
  width: 100%;
  min-height: ${props => (props?.fixedArea ? '220px' : 'auto')};
  height: auto;
  @media (--to-tablet) {
    flex-direction: column;
  }
`;

export const ButtonContainer = styled.div`
  @media (--from-tablet) {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: var(--space-350);
  }
  @media (--only-mobile) {
    display: flex;
    flex-direction: column;
    align-items: start;
    margin-bottom: var(--space-350);
  }
`;

export const HeaderContainer = styled.div`
  @media (--only-mobile) {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }
`;

export const InputsContainer = styled.div<{ last: boolean }>`
  @media (--only-mobile) {
    margin-top: ${props => (props.last ? '16px' : '24px')};
  }
`;

export const styledTabList = css`
  button {
    &:first-child {
      margin-left: 0px !important;
    }
  }
`;

export const LayingTypeContainer = styled.div`
  @media (--only-mobile) {
    margin-top: var(--space-400);
  }
`;

export const InputContainerRow = styled.div<{ direction?: string }>`
  @media (--from-tablet) {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: wrap;
    width: 100%;
  }
  @media (--only-mobile) {
    display: flex;
    flex-direction: ${props => (props?.direction === 'row' ? 'row' : 'column')};
    gap: var(--space-200);
    width: 100%;
  }
`;

export const InputContainerColumn = styled.div<{ last?: boolean }>`
  @media (--from-tablet) {
    display: flex;
    flex-direction: column;
    flex-basis: 48.5%;
    width: 100%;
    margin-bottom: ${props => (props.last ? '0px' : 'var(--space-350)')};
  }
  @media (--only-mobile) {
    flex-basis: 100%;
    margin-bottom: 0px;

    &:last-of-type {
      margin-top: var(--space-100);
    }
  }
`;

export const infobar = css`
  margin-bottom: var(--space-250);
  @media (--only-mobile) {
    margin-bottom: var(--space-350);
  }
`;
